import moment from 'moment';
import { call, put, select, StrictEffect, takeEvery } from 'redux-saga/effects';
import asyncErrorHandler from 'utils/asyncErrorHandler';
import { RootState } from 'store';
import { UserResponse } from 'types';
import { fetchUserPerformanceReport, UserPerformanceReport } from 'modules/report/services/userPerformanceReport';
import {
  getDashboardUserPerformance,
  setDashboardUserPerformanceData,
  setDashboardUserPerformanceError,
  setDashboardUserPerformanceLoading,
} from './dashboardUserPerformance-slice';

const DEFAULT_USER_TYPES = ['regular_user', 'freelancer'];
const DEFAULT_SOURCE = ['task', 'request'];
const DEFAULT_PLANS = ['starter', 'premium', 'enterprise', 'custom', 'hosting'];

function* getDashboardUserPerformanceSagaListener() {
  const user: UserResponse = yield select((store: RootState) => store.auth.user);

  try {
    yield put(setDashboardUserPerformanceLoading());

    const report: UserPerformanceReport = yield call(fetchUserPerformanceReport, {
      dateFrom: moment().subtract(30, 'day').format('YYYY-MM-DD'),
      dateTo: moment().format('YYYY-MM-DD'),
      userTypes: DEFAULT_USER_TYPES,
      source: DEFAULT_SOURCE,
      projectPlan: DEFAULT_PLANS,
      userUuid: user.uuid,
    });

    yield put(setDashboardUserPerformanceData(report));
  } catch (error) {
    yield put(setDashboardUserPerformanceError(error));
    asyncErrorHandler(error);
  }
}

function* dashboardFailedPaymentsSaga(): Generator<StrictEffect> {
  yield takeEvery(getDashboardUserPerformance.type, getDashboardUserPerformanceSagaListener);
}

export default dashboardFailedPaymentsSaga;
